// extracted by mini-css-extract-plugin
export default {"root":"BeX02"};